import * as React from "react"
import { Container, Modal, Row, Col, Button } from "react-bootstrap"
import WarningImage from "../assets/images/warning.png"
import ActionButton from "./ActionButton"

interface ConfirmationModalProps {
  show: boolean
  showImage?: boolean
  title?: string
  textTitle?: string
  text?: string
  cancelButtonText?: string
  confirmButtonText?: string
  children?: React.ReactNode
  size?: "lg"
  disableConfirmButton?: boolean
  spinConfirmButton?: boolean
  disableConfirmOnSpin?: boolean
  showCancelButton: boolean
  showCloseButton: boolean
  onHide: () => void
  onConfirm: () => void
}

export default class ConfirmationModal extends React.PureComponent<ConfirmationModalProps, {}> {
  render() {
    const { show, showImage, title, textTitle, text, cancelButtonText, confirmButtonText, children, size, disableConfirmButton, spinConfirmButton, disableConfirmOnSpin, onHide, onConfirm, showCancelButton, showCloseButton } = this.props
    return <Modal backdrop="static" centered show={show} onHide={onHide} size={size}>
      <Modal.Header closeButton={showCloseButton}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {children && children}
        {!children &&
          <Container fluid>
            <Row>
              {showImage && <Col sm={2}><img src={WarningImage} alt="" width="50" /></Col>}
              <Col>
                {textTitle && <h5>{textTitle}</h5>}
                {text && <p>{text}</p>}
              </Col>
            </Row>
          </Container>}
      </Modal.Body>
      <Modal.Footer>
        {showCancelButton && <Button variant="secondary" onClick={onHide} className="mr-auto fixed-w5">{cancelButtonText}</Button>}
        <ActionButton variant="primary" onClick={onConfirm} disabled={disableConfirmButton} spin={spinConfirmButton} disableOnSpin={disableConfirmOnSpin} className="fixed-w5">{confirmButtonText}</ActionButton>
      </Modal.Footer>
    </Modal>
  }

  static defaultProps = {
    title: "CONFIRM",
    showImage: true,
    cancelButtonText: "CANCEL",
    confirmButtonText: "CONFIRM",
    disableConfirmButton: false,
    spinConfirmButton: false,
    disableConfirmOnSpin: false,
    showCancelButton: true,
    showCloseButton: true
  }
}